import actionTypes from '../constants/action-types';
import setPageHTML from '../actions/set-page-html';
import setHtmlCheckpoint from '../actions/set-html-checkpoint';
import getPage from '../selectors/page';
import fetchPageHTML from '../helpers/fetch-page-html';
import getCurrentLocale from '../../site-locales/selectors/current-locale';
import getMainLocale from '../../site-locales/selectors/main-locale';
import getHomePage from '../selectors/home-page';

const pageFetcher = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.UPDATE_PAGE_SETTINGS:
    case actionTypes.SET_ACTIVE_PAGE: {
      const state = store.getState();
      let page = getPage(state, action.payload.pageId);
      let newAction = action;

      if (!page) {
        const currentLocale = getCurrentLocale(state);
        const mainLocale = getMainLocale(state);

        const homePageLocale = currentLocale || mainLocale;
        page = getHomePage(state, homePageLocale);
        newAction = {
          ...action,
          payload: {
            ...action.payload,
            pageId: page.id,
          },
        };
      }

      if (page.html) {
        next(newAction);
        return;
      }

      fetchPageHTML(page.source, { encode: true }).then((pageHTML) => {
        store.dispatch(setPageHTML(newAction.payload.pageId, pageHTML));
        store.dispatch(setHtmlCheckpoint(newAction.payload.pageId, pageHTML));

        next(newAction);
      });
      break;
    }

    case actionTypes.TRANSLATE_PAGE:
    case actionTypes.COPY_PAGE: {
      const state = store.getState();
      const { targetPageId } = action.payload;
      const targetPage = getPage(state, targetPageId);

      if (targetPage.html) {
        next(action);
        return;
      }

      fetchPageHTML(targetPage.source, { encode: true }).then((pageHTML) => {
        store.dispatch(setPageHTML(targetPageId, pageHTML));
        store.dispatch(setHtmlCheckpoint(targetPageId, pageHTML));

        next(action);
      });
      break;
    }

    default:
      next(action);
  }
};

export default pageFetcher;
